export function isMobileApplication(): boolean {
  return (window as any).Capacitor.isNativePlatform();
}
